export const getSocketsUrl = () => {
  const host = window.location.host

  if (host === "labrador.network") {
    return import.meta.env.VITE_SOCKETS_PROXY
  }

  return import.meta.env.VITE_SOCKETS_URL
}
